import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { getAllConfigPropertiesForBrandAndInfluencerFailure, getAllConfigPropertiesForBrandAndInfluencerSuccess } from '../../actions/publicActions/getAllConfigPropertiesForBrandAndInfluencerActions';

function* getAllConfigPropertiesForBrandAndInfluencer({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getAllConfigPropertiesForBrandAndInfluencer,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_SUCCESS status :", response.data.status);
        console.log("GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_SUCCESS data :", response.data.response);
        console.log("GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getAllConfigPropertiesForBrandAndInfluencerSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_FAILURE status :", error?.response?.status);
        console.log("GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_FAILURE data:", error?.response?.data);
        console.log("GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_FAILURE error :", error);
        console.log('====================================');
        yield put(getAllConfigPropertiesForBrandAndInfluencerFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getAllConfigPropertiesForBrandAndInfluencerSaga() {
    yield takeLatest(actionTypes.GET_ALL_CONFIG_PROPERTIES_FOR_BRAND_AND_INFLUENCER_REQUEST, getAllConfigPropertiesForBrandAndInfluencer);
}

export default getAllConfigPropertiesForBrandAndInfluencerSaga;
